import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLazyGetQuizQuery } from "../../slices/fun_stuff/quizSlice";
import { Card } from "react-bootstrap";
import TopicInput from "./TopicInput";
import ToggleSwitch from "../ToggleSwitch";
import FishLoader from "../FishLoader";
import Message from "../Message";

const GenerateQuiz = ({ setQuiz, hideAnswers, setQuizzesRemaing, quizzesRemaining }) => {
    const { quizUserInfo } = useSelector((state) => state.quizAuth);

    const [quizParams, setQuizParams] = useState({ topic: '', level: '', number: 10 });
    const [modelSliderChecked, setModelSliderChecked] = useState(false);
    const [model, setModel] = useState('gpt-4-turbo');
    
    const debounceRef = useRef(null);

    const [getQuiz, { isLoading: quizLoading, error: quizError }] = useLazyGetQuizQuery();

    useEffect(() => {
      modelSliderChecked ? setModel('gpt-4-turbo') : setModel('gpt-3.5-turbo');
    }, [modelSliderChecked]);

    useEffect(() => {
      if (quizUserInfo) {
          setQuizParams((prev) => ({
              ...prev,
              id: quizUserInfo.id
          }));
          setModelSliderChecked(true);
          if (quizUserInfo.quizzes_remaining) {
              setQuizzesRemaing(quizUserInfo.quizzes_remaining)
          }
      }
    }, [quizUserInfo]);

    function generateQuizDebounced(topic, level, number) {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
          generateQuiz(topic, level, number);
        }, 500);
      }

    async function generateQuiz(topic, level, number) {
        setQuiz(null);
        hideAnswers();
        setQuizParams({
          topic,
          level,
          number
        });

        try {
            const result = await getQuiz({ topic, level, number, model }, { forceRefetch: true }).unwrap();
            setQuiz(result);

            // For beta testers
            setQuizzesRemaing(quizzesRemaining - 1); 
        } catch (error) {
            console.error('Quiz fetch failed:', error);
            window.alert("Something went wrong getting the quiz.");
        }
    }

    if (quizLoading) return <FishLoader topic={quizParams.topic} level={quizParams.level}/>;
    if (quizError) return <Message>{quizError?.data?.message}</Message>;

    return (
    <Card className="my-4 shadow-sm">
      <Card.Header className="card-header-dark">
        Generate a quiz on any topic
      </Card.Header>

      <Card.Body>
        <div className="mb-4">
          <div className="c-flex flex-column flex-md-row align-items-center justify-content-center gap-4 text-center mb-3">
          {quizUserInfo ? (
            <div>
              <p>
                  You can generate <strong>10 "good"</strong> quizzes each day.
                  Toggle <strong>High-quality</strong> for the best experience,
                  or use <strong>Basic</strong> mode to play around. This doesn't
                  apply to other user-generated quizzes.
              </p>
              <h6 className="mb-0">Good quizzes remaining:</h6>
              <h5 className="text-success">{quizzesRemaining}</h5>
            </div>
          ) : (
            <p>
              Login to access the high-quality quiz generation.
            </p>
          )}

            <div className="c-flex align-items-center gap-2 mx-3">
              <h4 className="mt-3 width-medium">{modelSliderChecked ? 'High-quality' : 'Basic'}</h4>
              <ToggleSwitch 
                  checked={Boolean(quizUserInfo && modelSliderChecked)}
                  onChangeFunction={setModelSliderChecked} 
                  disabled={!quizUserInfo}   
              />
              <p className="fs-6 my-0">{modelSliderChecked ? '*toggle for Basic' : '*toggle for High-quality'}</p>
            </div>
          </div>
        </div>

        <TopicInput
          numberDefault={10}
          submitTopic={generateQuizDebounced}
          liveGame={false}
        />

      </Card.Body>
    </Card>
    )
}

export default GenerateQuiz